import React from 'react';
import { StyledNavSecondaryContainer } from '../../components/NavSecondary/Styles';
import useCurrentTradeState from '../../_shared/hooks/trade/useCurrentTradeState';
import NavSecondary from '../../components/NavSecondary';
import useCurrentTradeContext from '../../_shared/hooks/trade/useCurrentTradeContext';
import PendingContainer from '../../components/Pending/PendingContainer';

const Pending = () => {
  const tradeState = useCurrentTradeState();
  const tradeContext = useCurrentTradeContext();

  return (
    <>
      <NavSecondary tradeState={tradeState} />
      <StyledNavSecondaryContainer>
        <PendingContainer tradeContext={tradeContext} />
      </StyledNavSecondaryContainer>
    </>
  );
};

export default Pending;
